import React, { useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Icon, Button, Link } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/pt-br';

import { useNewAppointment } from '../context';
import useStyles from './styles';

const Confirmation = () => {
  const classes = useStyles();
  const { newAppointmentInfos, sendNewAppointment } = useNewAppointment();
  const history = useHistory();
  const {
    infos: { term: linkTerms },
    professionals: { list: listProfessionals },
    schedule: {
      columns: { timetable },
    },
  } = useSelector(state => state.appointments);

  const goToSchedule = useCallback(() => {
    history.push('/appointments/new');
  }, [history]);

  const goToInformations = useCallback(() => {
    history.push('/appointments/new/informations');
  }, [history]);

  const appointmentDateInfos = useMemo(() => {
    if (!Object.keys(timetable).length) return {};
    const { timeTableId, columnDate } = newAppointmentInfos;
    const { startTime, endTime } = timetable[timeTableId];
    return {
      day: moment.utc(columnDate).startOf('day').locale('pt-br').format('dddd'),
      date: moment.utc(columnDate).startOf('day').format('DD/MM/YYYY'),
      hour: `${startTime} às ${endTime}`,
    };
  }, [newAppointmentInfos, timetable]);

  const professionalInfos = useMemo(() => {
    const professionalSelected =
      listProfessionals[newAppointmentInfos.professionalId];
    return professionalSelected;
  }, [listProfessionals, newAppointmentInfos]);

  useEffect(() => {
    const {
      timeTableId,
      columnDate,
      professionalId,
      contact,
      mainDoubt,
    } = newAppointmentInfos;

    if (!timeTableId || !columnDate || !professionalId) {
      goToSchedule();
      return;
    }
    if (!contact || !mainDoubt) {
      goToInformations();
    }
  }, [goToSchedule, goToInformations, newAppointmentInfos]);

  return (
    <Box className={classes.container}>
      <Box className="confirmation-header">
        <Typography>Confirme as informações do agendamento:</Typography>
      </Box>
      <Box className="confirmation-body">
        <Box className="confirmation-info-container">
          <Typography className="confirmation-info-label" variant="overline">
            Data do agendamento:
          </Typography>
          <Box className="confirmation-info-content">
            <Box className="confirmation-info-icon-container">
              <Icon color="primary">event</Icon>
            </Box>
            <Box className="confirmation-info-text-container">
              <Typography
                className="confirmation-info-text-primary"
                variant="body1"
              >
                {appointmentDateInfos?.day}
              </Typography>
              <Typography
                className="confirmation-info-text-secondary"
                variant="body2"
              >
                {`${appointmentDateInfos?.date} - ${appointmentDateInfos?.hour}`}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className="confirmation-info-container">
          <Typography className="confirmation-info-label" variant="overline">
            Profissional:
          </Typography>
          <Box className="confirmation-info-content">
            <Box className="confirmation-info-icon-container">
              <Icon color="primary">person</Icon>
            </Box>
            <Box className="confirmation-info-text-container">
              <Typography
                className="confirmation-info-text-primary"
                variant="body1"
              >
                {professionalInfos?.name}
              </Typography>
              <Typography
                className="confirmation-info-text-secondary"
                variant="body2"
              >
                {professionalInfos?.contact}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Typography className="confirmation-terms-container" variant="caption">
          {`Ao confirmar, você concorda com os `}
          <Link
            className="confirmation-terms-link"
            color="inherit"
            underline="always"
            href={linkTerms}
            target="_blank"
          >
            termos e condições
          </Link>
        </Typography>
      </Box>
      <Box className="confirmation-footer">
        <Button onClick={goToSchedule}>Trocar horário</Button>
        <Button
          onClick={sendNewAppointment}
          color="inherit"
          className="confirmation-btn-confirm"
        >
          Confirmar agendamento
        </Button>
      </Box>
    </Box>
  );
};

export default Confirmation;
